import {hrmsWithPath} from "../../services/http/api/rest";

const base = '/v1/';
const rest = hrmsWithPath("/v1/employee");
const hrmsV1 = hrmsWithPath("/v1")

const employee = {
    admin: {
        markEmployeeInActive: (empID: string) => rest.put(`/{{empID}}/inactive`, {empID}, {}, {}),
        import: (employees: any) => rest.post('/import', {}, employees),
        assignSupervisor: (empId: string, managerId: string) => rest.put(`/{{empId}}/reporting-manager/{{managerId}}`, {
            empId,
            managerId
        }, {}, {}),
        importUsersWithEmployee: (employees: any) => rest.post('/import', {}, employees, {}),
        hasSupervisor: (id: string) => rest.get('/{{id}}/is-reporting-to', {id}),
        removeSupervisor: (id: string) => rest.put('/{{id}}/remove-supervisor', {id}),
    },
    getAllReportees: (empId: string, pageNumber?: number, pageSize?: number) => rest.get(`/{{empId}}/reportees`, {empId}, {
        "page-number": pageNumber,
        "page-size": pageSize
    }),
    get: (id: string) => rest.get('/{{id}}', {id}),
    update: (id: any, data: object) => rest.put('/{{id}}', {id}, data),
    search: (data?: any, pageSize?: number, pageNumber?: number) => rest.post("/search", {}, data, {
        "page-size": pageSize,
        "page-number": pageNumber
    }),
    getAllEmployee: () => rest.get('/all', {}, {}),
    eligibleReportingManagers: (data: any) => rest.post('/eligible-reporting-managers', {}, data),
    primary: {
        get: (id: string) => rest.get('/{{id}}/primary-detail', {id}),
        create: (data: any) => rest.post('', {}, data),
        update: (empId: string, data: any) => rest.put('/{{empId}}/primary-detail', {empId}, data),
        list: null,
    },
    contact: {
        get: (empId: string) => rest.get('/{{empId}}/contact-detail', {empId}),
        update: (empId: string, data: any) => rest.put('/{{empId}}/contact-detail', {empId}, data),
    },
    qualification: {
        get: (empId: string) => rest.get('/{{empId}}/qualification-detail', {empId}),
        update: (empId: string, data: any) => rest.put('/{{empId}}/qualification-detail', {empId}, data),
    },
    experience: {
        get: (id: string) => rest.get('/{{id}}/experience', {id}),
        update: (id: string, data: any) => rest.put('/{{id}}/experience', {id}, data, {}),
    },
    family: {
        get: (empId: string) => rest.get('/{{empId}}/family-detail', {empId}),
        update: (empId: string, data: {}) => rest.put('/{{empId}}/family-detail', {empId}, data),
    },
    bank: {
        get: (empId: string) => rest.get('/{{empId}}/bank-detail', {empId}),
        create: (empId: string, data: {}) => rest.post('/{{empId}}/bank-detail', {empId}, data),
        update: (empId: string, bankId: string, data: {}) => rest.put('/{{empId}}/bank-detail/{{bankId}}', {
            empId,
            bankId
        }, data),
    },

    //check-in and check-out
    checkIn: (id: string) => hrmsV1.post('/check-in', {id}, {}),
    checkOut: (id: string) => hrmsV1.post('/check-out', {id}, {}),
    checkReportingManagerStatus: (id: string) => rest.get(`/{{id}}/is-reporting-manager`, {id}, {}),
    employeeDetailsByID: (id: any, pathArgs: any) => rest.get(`/{{id}}`, {id}, pathArgs),
    employeeBasicDetailsById: (id: string) => rest.get('/{{id}}/basic-details', {id}),
}

export default employee;
